import React from 'react'

import ReactDOM from 'react-dom'

import './api/axiosConfig'

import './styles/index.scss'
import { PublicClientApplication, EventType } from '@azure/msal-browser'

import { initAnalytics } from './analytics'
import { TEMP_LOG_FUNCTION } from './api/auth'
import App from './components/views/App'
import { ensureIntegrationHotspotCssVar } from './config/integrationHotspotCssVar'
import { msalConfig } from './msAuthConfig'

const msalInstance = new PublicClientApplication(msalConfig)

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents()

// Listen for sign-in event and set active account
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper event type
msalInstance.addEventCallback((event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account
    msalInstance.setActiveAccount(account)
    // eslint-disable-next-line no-console -- TODO: Remove debug console.log
    console.log('MSAL LOGIN SUCCESS: ', event)
    TEMP_LOG_FUNCTION(`MSAL LOGIN SUCCESS: ${JSON.stringify(event)}`)
  } else if (event.eventType === EventType.LOGIN_FAILURE) {
    // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
    console.error('MSAL LOGIN FAILURE: ', event)
    TEMP_LOG_FUNCTION(`MSAL LOGIN FAILURE: ${JSON.stringify(event)}`)
    msalInstance.setActiveAccount(null)
    window.location.replace('/')
  }
})

// Suppress ResizeObserver loop error (harmless and often from Recharts in safety metric tiles)
window.addEventListener('error', (event: ErrorEvent) => {
  if (event.message?.includes?.('ResizeObserver loop')) {
    event.preventDefault()
    event.stopImmediatePropagation()
    return true
  }
})

ensureIntegrationHotspotCssVar()

initAnalytics()
ReactDOM.render(
  <React.StrictMode>
    <App msalInstance={msalInstance} />
  </React.StrictMode>,
  document.getElementById('root'),
)
